import Vue from "vue";
import Message from "./main";
const MessageConstructor = Vue.extend(Message);


function notification(options, domNode) {
  const instance = new MessageConstructor({ data: options });
  instance.$mount();
  domNode.appendChild(instance.$el);
}

export default notification;
